export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
  {
  icon: 'toggle-on',
  title: 'Activate Selected Docks',
  cls: "bulk-activate-dock",
  disabled:true
  },
  {
  icon: 'toggle-off',
  title: 'Deactivate Selected Docks',
  cls: "bulk-deactivate-dock",
  disabled:true
  }
  ],
  "actions": [
  {
  title: "Edit",
  cls: "edit-dock",
  icon: "pencil",
  disabled:false
  },
  {
  title: "Copy",
  cls: "copy-dock",
  icon: "clone",
  disabled:false
  },
  {
  title: "Activate/Deactivate",
  cls: "",
  icon: "",
  disabled:false
  }
  ]
 };


// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/filter/actionOptions.js